import _ from 'lodash';
import moment from 'moment';
import { DateRangeSchema } from './types';

export const encodeDateRange = (obj: DateRangeSchema | null): string | null => {
  if (_.isNil(obj)) {
    return null;
  }
  if (Object.values(obj).every((value: string | null) => value === null)) {
    return null;
  }
  // remove null values from URL so we reduce the url length
  const nonNullValues = _.pickBy(obj, _.identity);
  const keys: (keyof Partial<DateRangeSchema>)[] = ['startDate', 'endDate', 'exactDate'];
  keys.forEach((k) => {
    const value = nonNullValues[k];
    if (moment.isMoment(value)) {
      // eslint-disable-next-line
      // @ts-ignore
      nonNullValues[k] = value.format('YYYY-MM-DD');
    }
  });

  return JSON.stringify(nonNullValues);
};

export const decodeDateRange = (objStr: string | null | undefined): DateRangeSchema | null => {
  if (_.isNil(objStr)) {
    return null;
  }
  const objFromUrl = JSON.parse(objStr);
  const keys: (keyof DateRangeSchema)[] = [
    'startDate',
    'endDate',
    'includeStartDate',
    'includeEndDate',
    'exactDate',
  ];
  keys.forEach((key) => {
    if (!(key in objFromUrl)) {
      objFromUrl[key] = null;
    }
  });
  return objFromUrl;
};
